/*
 * @Date: 2022-08-05 09:22:30
 * @Author: Yao guan shou
 * @LastEditors: Yao guan shou
 * @LastEditTime: 2022-08-16 19:07:47
 * @FilePath: /react-ssr-lazy-loading/@/App/App.js
 * @Description:
 */
// import "antd/dist/antd.css";
import './index.scss';
// import "@/static/css/katex/katex.css";
// import "./index.css";
import '@/assets/css/base.scss';
import '@/assets/css/tailwind.css';

import { ConfigProvider, Modal, Button } from 'antd';
// 由于 antd 组件的默认文案是英文，所以需要修改为中文
import zhCN from 'antd/es/locale/zh_CN';

import React, { Component, Suspense } from 'react';

import { Provider } from 'react-redux';
import { getToken, getVersion } from '@/apis';
import { token } from '@/apis/request';
// import RoutesComponentProvider from '@/router/RoutesComponentProvider.js';
import VersionUpdate from '@/components/ui/VersionUpdate';
import ReduxProvider from '@/components/ReduxProvider';
import WagmiProvider from '@/components/WagmiProvider';
import ConfirmProvider from '@/components/ConfirmProvider';
import MessageProvider from '@/components/MessageProvider';
import { LocalStorage } from '@/storage';
import { RouterProvider } from 'react-router-dom';
import router from '@/router';
import Spin from '@/components/ui/Spin';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import 'dayjs/locale/zh-cn';
import 'dayjs/locale/zh-hk';
import 'dayjs/locale/en';

import { getAntdLanguage } from '@/components/Language';
import { I18nextProvider } from 'react-i18next';
import i18n from '@/i18n';
// import 'tailwindcss/tailwind.css';
// let {
//   NODE_ENV, // 环境参数
//   HTML_WEBPACK_PLUGIN_OPTIONS = ""
// } = process.env; // 环境参数

dayjs.extend(utc);
dayjs.extend(timezone);

const Loading = () => null; // <Spin className="h-[100vh]" isLoading={true} />;

class Index extends Component {
    componentDidMount() {
        const { history, store, routesComponent } = this.props;
        // const mapLanguage: { [key: string]: string } = {
        //   zh: 'zh-cn',
        //   en: 'en',
        //   hk: 'zh-hk'
        // };
        // dayjs.locale('zh-cn');
        // dayjs.extend(updateLocale);
        // dayjs.updateLocale('zh-cn', {
        //   weekStart: 0,
        // });
        // token.get().then((value) => {
        //   if (!value) {
        //     getToken();
        //   }
        // });
    }

    render() {
        const { history, store, routesComponent } = this.props;

        const defaultData = {
            borderRadius: 6,
            colorPrimary: '#005ddc',
        };

        /*
Warning: Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported.
来自Provider组件
*/

        return (
            <ReduxProvider>
                <I18nextProvider i18n={i18n}>
                    <WagmiProvider>
                        <ConfigProvider
                            theme={{
                                token: {
                                    colorPrimary: defaultData.colorPrimary,
                                    borderRadius: defaultData.borderRadius,
                                },
                            }}
                            locale={getAntdLanguage(i18n.language)}
                        >
                            <ConfirmProvider>
                                <MessageProvider>
                                    <Suspense fallback={<Loading />}>
                                        <VersionUpdate
                                            listen={(callback = () => {}) => {
                                                // 全局监听路由变化（替代history.listen）
                                                router.subscribe((state) => {
                                                    // 可在此实现埋点、权限校验、页面标题修改等逻辑
                                                    // 发送请求
                                                    callback({ location: state.location });
                                                });
                                            }}
                                        />

                                        <RouterProvider router={router} />
                                    </Suspense>
                                </MessageProvider>
                            </ConfirmProvider>
                        </ConfigProvider>
                    </WagmiProvider>
                </I18nextProvider>
            </ReduxProvider>
        );
    }
    componentDidCatch(error, info) {
        // 只能捕获子组件的渲染错误
        /*
异步代码中的错误（如 setTimeout、fetch）
事件处理器中的错误（如 onClick）
服务端渲染错误
错误边界组件本身的错误
*/
        console.error('Error：', error);
        console.error('错误发生的文件栈：', info.componentStack);
    }
}

// Index.propTypes = {
//     location: PropTypes.string,
//     store: PropTypes.object,
//     history: PropTypes.object,
//     dispatch: PropTypes.func,
//     state: PropTypes.object,
// };

export default Index;
